import { render, staticRenderFns } from "./className.vue?vue&type=template&id=00bd9af8&scoped=true"
import script from "./className.vue?vue&type=script&lang=js"
export * from "./className.vue?vue&type=script&lang=js"
import style0 from "./className.vue?vue&type=style&index=0&id=00bd9af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd9af8",
  null
  
)

export default component.exports